// utils/error.ts (или внутри PlateForm.tsx)

import { AxiosError } from 'axios';

/**
 * Извлекает наиболее релевантное сообщение об ошибке из объекта исключения.
 * Предпочтение отдается подробным сообщениям из тела ответа Axios (4xx/5xx).
 * @param error Объект исключения (может быть Error, AxiosError или любым другим)
 * @param defaultMessage Сообщение по умолчанию, если не удалось извлечь конкретное
 * @returns Строка с сообщением об ошибке
 */
export function getErrorMessage(error: unknown, defaultMessage: string): string {
  // 1. Проверка на объект AxiosError (наиболее вероятный сценарий сбоя API)
  if (
    // Проверяем, что это объект с нужной структурой
    typeof error === 'object' &&
    error !== null &&
    'isAxiosError' in error &&
    error.isAxiosError &&
    'response' in error
  ) {
    const axiosError = error as AxiosError;
    
    // Пытаемся извлечь подробное сообщение из тела ответа (response.data.message)
    // Структура data: { message: "...", code: "..." }
    if (
      axiosError.response &&
      axiosError.response.data &&
      typeof axiosError.response.data === 'object' &&
      axiosError.response.data !== null &&
      'message' in axiosError.response.data
    ) {
      // Возвращаем подробное сообщение об ошибке (например, "duplicate key value violates...")
      return axiosError.response.data.message as string;
    }
    
    // Если нет подробного тела, возвращаем общее сообщение Axios
    if (axiosError.message) {
      return axiosError.message; // Например, "Request failed with status code 409"
    }
  }

  // 2. Проверка на стандартный объект Error
  if (error instanceof Error) {
    return error.message;
  }

  // 3. Fallback
  return defaultMessage;
}